import React from 'react';
import { Award, Film, Users } from 'lucide-react';

const CredibilitySection = () => {
  const credentials = [
    {
      icon: Film,
      stat: "50+",
      label: "Book Trailers Produced"
    },
    {
      icon: Users,
      stat: "100+",
      label: "Authors Served"
    },
    {
      icon: Award,
      stat: "10+",
      label: "Years Experience"
    }
  ];

  return (
    <section className="py-20 px-4 bg-[#040c14] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="abstract-blob animate-float-delayed" style={{ 
          bottom: '20%', 
          left: '10%', 
          width: '450px', 
          height: '450px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.2), transparent 70%)',
          filter: 'blur(85px)'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left: Harry Mann Bio */}
          <div className="space-y-6">
            <div>
              <p className="text-sm text-[#FF6500] uppercase tracking-widest mb-2">
                Meet Your Creative Director
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Harry Mann
              </h2>
            </div>
            
            <p className="text-[#aaa] leading-relaxed">
              For most authors, studio-quality cinematic materials have always been out of reach. 
              The kind of visual development work that gets stories taken seriously costs hundreds 
              of thousands of dollars and requires a full production team.
            </p>
            
            <p className="text-white font-medium text-lg">
              Harry Mann built Augmented Cinematics to change that.
            </p>
            
            <p className="text-[#aaa] leading-relaxed">
              As a creative director with over a decade of studio and filmmaking experience, 
              Harry spent years understanding exactly what makes a story translate visually. 
              The character development, the tone, the cinematic pacing that signals to producers 
              and audiences alike that this world is real and worth investing in.
            </p>
            
            <p className="text-[#aaa] leading-relaxed">
              By combining that creative foundation with modern generative visual technology, 
              he developed a production model that delivers that same level of intentional, 
              story-driven visual development <strong className="text-white">at a fraction of the traditional cost</strong>, 
              making it accessible to independent and debut authors for the first time.
            </p>
            
            <p className="text-[#aaa] leading-relaxed italic border-l-2 border-[#FF6500] pl-4">
              The result isn't a shortcut. It's a smarter pipeline, built by someone who knows 
              what the finished product needs to look like and has the creative experience to get it there.
            </p>

            <div className="pt-4">
              <a 
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#FF6500] hover:bg-[#E65A00] text-black font-medium rounded-full transition-all duration-300 text-sm uppercase tracking-wider"
              >
                Work With Harry
              </a>
            </div>
          </div>

          {/* Right: Stats Grid */}
          <div className="space-y-6">
            <div className="grid grid-cols-3 gap-4">
              {credentials.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div 
                    key={index}
                    className="bg-[#0a1525] border border-[#152840] rounded-xl p-5 text-center hover:border-[#FF6500]/30 transition-colors duration-300"
                  >
                    <div className="w-10 h-10 bg-[#FF6500]/10 rounded-full flex items-center justify-center mx-auto mb-3">
                      <Icon className="w-5 h-5 text-[#FF6500]" />
                    </div>
                    <div className="text-2xl font-bold text-white mb-1">{item.stat}</div>
                    <div className="text-xs text-[#aaa]">{item.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
